const setContactAgreeCheck = () => {
  const privacyCheck = document.querySelector('#js-agree-check');
  const submitBtn = document.querySelector('#js-contact-submit-btn');

  function judgePrivacyCheck() {
    if (privacyCheck?.checked) {
      submitBtn.disabled = false;
    } else {
      submitBtn.disabled = true;
    }
  }

  privacyCheck?.addEventListener('change', judgePrivacyCheck);

  window.addEventListener('pageshow', judgePrivacyCheck);

  judgePrivacyCheck();
};

export default setContactAgreeCheck;
